import { render, staticRenderFns } from "./Medias.vue?vue&type=template&id=2b1ec03f&scoped=true"
import script from "./Medias.vue?vue&type=script&lang=ts"
export * from "./Medias.vue?vue&type=script&lang=ts"
import style0 from "./Medias.vue?vue&type=style&index=0&id=2b1ec03f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1ec03f",
  null
  
)

export default component.exports